'use strict';

var Handlebars = require('hbsfy/runtime');
var moment = require('moment-timezone');

var polyglot = require('./polyglot').default;

Handlebars.registerHelper('currentDate', function (format) {
  return moment().format(format);
});

Handlebars.registerHelper('formatDate', function (str, from, to) {
  return moment(str, from).format(to);
});

Handlebars.registerHelper('weekdays', function (format, number) {
  return moment.weekdays(format, number);
});

Handlebars.registerHelper('t', function (str, params) {
  if (arguments.length === 3) {
    return polyglot.t(str, params);
  }

  return polyglot.t(str);
});
